module.exports = __webpack_public_path__ + "static/media/thinx.5c0b9e1f.gif";